import { render, staticRenderFns } from "./SearchKeywordInput.vue?vue&type=template&id=20c7a0b7&scoped=true&"
import script from "./SearchKeywordInput.vue?vue&type=script&lang=ts&"
export * from "./SearchKeywordInput.vue?vue&type=script&lang=ts&"
import style0 from "./SearchKeywordInput.vue?vue&type=style&index=0&id=20c7a0b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c7a0b7",
  null
  
)

export default component.exports